import { Spinner } from 'react-bootstrap';
import './loader.scss';
interface PreloaderProps {
  loading: boolean;
  extraClass?: string;
}
export function Preloader({ loading, extraClass }: PreloaderProps) {
  // for the entire page, to indicate loading on refresh
  if (loading) {
    return (
      <div className={`mt-0 content-loader ${extraClass ? extraClass : ''}`}>
        <Spinner animation="border" className="spin-loader" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  } else {
    return null;
  }
}

export function PreloaderComponent() {
  return (
    <section
      style={{
        /*  height: '100vh', */
        width: '100%',
        padding: 'calc(100px + 1.5625vw) 0',
        textAlign: 'center',
      }}
      className="preloader-component"
    >
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </section>
  );
}
